import Icon from '../components/Icon.vue'

Icon.register({
  'pound-sign': {
    width: 320,
    height: 512,
    paths: [
      {
        d: 'M308 352c6.6 0 12 5.4 12 12v104c0 6.6-5.4 12-12 12h-296c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h36v-128h-28c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h28v-66c0-73.2 58-126 139.9-126 48.6 0 85.2 22.6 101.6 34.9 5.4 4.1 6.4 11.8 2.1 17.1l-28.5 35.5c-3.8 4.7-10.5 5.9-15.7 2.7-11.8-7.3-34-18.8-57.7-18.8-37.2 0-61.8 24.8-61.8 57.1v63.6h84c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-84v126.8h122.5v-50.8c0-6.6 5.4-12 12-12h45.5z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/pound-sign.js
// module id = 1657
// module chunks = 0